<template>
  <div class="mx-auto w-full max-w-[340px] rounded-[2.75rem] bg-[#0f2c2c] p-2.5 shadow-2xl shadow-[#1c4848]/30">
    <div class="relative overflow-hidden rounded-[2.25rem] bg-[#f4f6f6]" :class="heightClass">
      <div class="absolute left-1/2 top-2 z-10 h-5 w-24 -translate-x-1/2 rounded-full bg-[#0f2c2c]" aria-hidden="true"></div>
      <div class="h-full overflow-y-auto custom-scrollbar px-4 pb-6 pt-11 space-y-5">
        <p class="font-serif text-lg font-semibold text-[#1c4848]">{{ title }}</p>
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup>
/** A phone around the feed cards, so the admin sees what a reader sees. */
defineProps({
  title: { type: String, default: 'Deenly' },
  heightClass: { type: String, default: 'h-[640px]' },
});
</script>

<style scoped>
.custom-scrollbar::-webkit-scrollbar { width: 4px; height: 4px; }
.custom-scrollbar::-webkit-scrollbar-track { background: transparent; }
.custom-scrollbar::-webkit-scrollbar-thumb { background-color: rgba(28, 72, 72, 0.1); border-radius: 20px; }
</style>
